define('views/modules/calendar/animated-session/animation/animation-rename-modal',[
    // Libs
    'underscore', 'backbone', 'mustache', 'utils',
    // services
    'services/i18n',
    'services/events/animated-session-events',
    // views
    'views/parts/modal/modal',
    'views/modules/calendar/animated-session/animation/rename/form/animation-rename-form',
    // templates
    'text!templates/modules/calendar/animated-session/animation/rename/animation-rename-modal.html'

], function(
    // Libs
    _, Backbone, Mustache, U,
    // services
    i18n,
    AnimationEvents,
    // views
    VModal,
    VAnimationRenameForm,
    // templates
    TAnimationRenameModal
) {

    var VAnimationRenameModal = VModal.extend({
        template: TAnimationRenameModal,
        modal: {
            title: '',
            className: "animation-rename-modal",
            backdrop: true,
            closeButton: false,
        },
        buttons: function(buttons) {
            return _.extend(buttons, {
                revert: {
                    label: i18n.t("exercise-revert-back"),
                    callback: this.onRevertBack,
                    className: !this.animation.get('_isRenamed') ? " hide" : ""
                },
                confirm: {
                    label: i18n.t("Rename"),
                    callback: this.onConfirm,
                    className: "btn-primary"
                }
            });
        },

        regions: {
            form: '#animation-rename-form'
        },

        initialize: function(opt) {
            this.options = opt || {};

            this.animation = null;

            this.group = this.options.group;

            var view = this.view = {
                form: new VAnimationRenameForm({
                    group: this.group
                })
            };

            this.listenTo(view.form, 'form:success', this.onSuccess);
        },

        render: function() {
            this.$el.empty()
                .append(Mustache.render(this.template, Mustache.getContext()));

            this.modal.title = i18n.t('calendar:rename-modal-title');

            this.generateZones()
                .assign(this.view.form, this.zone.$form)
                .renderModal();

            return this;
        },

        setAnimation: function(animation) {
            this.animation = animation;
            this.view.form.resetWithAnimation(animation);
            return this;
        },

        onRevertBack: function() {
          this.animation.trigger('animation:revertback');
        },

        onConfirm: function(result) {
            if (result) {
                this.view.form.submit();
                return false;
            }
        },

        onSuccess: function() {
            this.close();
            this.trigger('form:success');
            AnimationEvents.exerciseRenamed(this.view.form.masterCarbon.clone());
        },

    });

    return VAnimationRenameModal;

});

